import { CONST } from "../CONST";

const MAX_PROJECTION_POINTS = 30;
const PROJECTION_LINE_LENGTH = 700;
const SKIP_UPDATE_NUM = 3;
const POINT_SCALE = 0.5;

export default class ProjectionLine {
  constructor(scene, ballX, ballY, ballScale, ballMass, speed, gravityScale, minYPosition) {
    this.speed = speed;
    this.startPos = {x: ballX, y: ballY};
    this.gravityScale = gravityScale;
    this.minY = minYPosition;

    this.projectionPointsGroup = scene.add.group({
        classType: Phaser.GameObjects.Image,
        key: CONST.BEERPONG.BLACK_CIRCLE,
        repeat: MAX_PROJECTION_POINTS,
        alpha: 0.3,
        active: false,
        visible: false,
    });

    this.hiddenBall = scene.matter.add.image(ballX,
        ballY, 
        CONST.BEERPONG.BALL,
        null,
        )
        .setFrictionAir(0)
        .setCircle()
        .setScale(ballScale, ballScale)
        .setMass(ballMass);

    this.hiddenBall.setVisible(false);
    this.hiddenBall.setStatic(true);
    this.hideHiddenBall(); // Needs to be done here because it interacts with constraint
  }

  updateProjectionPoints(
    pointerX,
    pointerY,
  ) {
    this.projectionPointsGroup.children.each(point => {
      point.setVisible(false);
      point.setActive(false);
    });

    this.hiddenBall.x = this.startPos.x;
    this.hiddenBall.y = this.startPos.y;
    this.hiddenBall.setVisible(false);
    this.hiddenBall.setStatic(false);
    const previousPos = {
      x: this.hiddenBall.x,
      y: this.hiddenBall.y,
    };

    this.hiddenBall.body.force.y = 0;
    this.hiddenBall.body.force.x = 0;
    this.hiddenBall.setVelocity(
      (pointerX - this.startPos.x) * this.speed,
      (pointerY - this.startPos.y) * this.speed
    );

    const projectionLineData = [
     /* {
        x: [this.hiddenBall.x],
        y: [this.hiddenBall.y],
      },*/
    ];
    let projectionLineLength = 0;
    let updateCounter = 0;
    do {
      updateCounter += 1;
      this.hiddenBall.body.force.y += this.hiddenBall.body.mass * this.gravityScale * 0.001; // gravityScale;

      // Run matterjs engine's update on our body
      Phaser.Physics.Matter.Matter.Body.update(
        this.hiddenBall.body,
        16.666666666666668,
        1,
        1
      );

      this.hiddenBall.body.force.x = 0;
      this.hiddenBall.body.force.y = 0;
      this.hiddenBall.body.torque = 0;

      if (updateCounter >= SKIP_UPDATE_NUM) {
        const ballUpdateDistance = Phaser.Math.Distance.Between(
          previousPos.x,
          previousPos.y,
          this.hiddenBall.x,
          this.hiddenBall.y
        );

        if (this.hiddenBall.y < this.minY){
          projectionLineData.push({ x: this.hiddenBall.x, y: this.hiddenBall.y });
        }

        previousPos.x = this.hiddenBall.x;
        previousPos.y = this.hiddenBall.y;

        projectionLineLength += ballUpdateDistance;
        updateCounter = 0;
      }
    } while (projectionLineLength < PROJECTION_LINE_LENGTH);

    this.hideHiddenBall();

    for (let index = 0; index < projectionLineData.length; index += 1) {
      const point = projectionLineData[index];
      const projectionPoint = this.projectionPointsGroup.getFirstDead();
      if (projectionPoint) {
        projectionPoint.setScale(POINT_SCALE);
        projectionPoint.x = point.x;
        projectionPoint.y = point.y;
        projectionPoint.setVisible(true);
        projectionPoint.setActive(true);
      }
    }
  }

  hideHiddenBall() {
    // HACK: Move the object further away, to use it later (cannot find away to temporarily remove)
   this.hiddenBall.x = 9999;
  this.hiddenBall.y = 9999;
  }
}
